import { z } from 'zod'
import type { ResolvedConfig } from './types.js'

const envSchema = z.object({
  NODE_ENV: z.enum(['development', 'production', 'test']).default('development'),
  PORT: z.coerce.number().default(3000),
  CORS_ORIGIN: z.string().default('*'),
  BACKEND_URL: z.string().optional(),
  DATABASE_URL: z.string().default('file:./dev.db'),
  REDIS_URL: z.string().url().optional(),
  REDIS_PREFIX: z.string().default('nexus'),
  ADMIN_EMAIL: z.string().email().optional(),
  ADMIN_PASSWORD: z.string().min(6).optional(),
  COOKIE_DOMAIN: z.string().optional(),
  TZ: z.string().default('UTC'),
  TRUST_PROXY: z.coerce.boolean().default(false),
  NEXUS_UI_ENABLED: z.coerce.boolean().default(true),
  NEXUS_UI_BASE: z.string().default('/'),
  NEXUS_UI_PATH: z.string().default('../ui/dist'),
  NEXUS_CHECK_DRIFT: z.coerce.boolean().optional(),
  NEXUS_FAIL_ON_DRIFT: z.coerce.boolean().optional(),
  FRPC_SERVER: z.string().optional(),
  FRPC_SERVER_PORT: z.coerce.number().default(7000),
  FRPC_TOKEN: z.string().optional(),
  FRPC_SUBDOMAIN: z.string().optional(),
  FRPC_PUBLIC_HOST: z.string().optional()
})

// Parse env vars. Re-parsed on each resolveConfig() to pick up runtime changes (tests).
let env = envSchema.parse(process.env)
export { env }

// Aplicar TZ inmediatamente al cargar el módulo
// UTC por defecto para consistencia con bases de datos
process.env['TZ'] = env.TZ

// Configuración global resuelta
let resolvedConfig: ResolvedConfig | null = null

export function resolveConfig(): ResolvedConfig {
  // Re-parse env to pick up changes made after module load (e.g. tests setting process.env.PORT)
  env = envSchema.parse(process.env)
  process.env['TZ'] = env.TZ

  resolvedConfig = {
    nodeEnv: env.NODE_ENV,
    port: env.PORT,
    host: '0.0.0.0',
    ui: {
      enabled: env.NEXUS_UI_ENABLED,
      base: env.NEXUS_UI_BASE,
      path: env.NEXUS_UI_PATH
    },
    corsOrigin: env.CORS_ORIGIN,
    databaseUrl: env.DATABASE_URL,
    adminEmail: env.ADMIN_EMAIL,
    adminPassword: env.ADMIN_PASSWORD,
    timezone: env.TZ
  }

  return resolvedConfig
}

export function getConfig(): ResolvedConfig {
  if (!resolvedConfig) {
    return resolveConfig()
  }
  return resolvedConfig
}

export function resetConfig(): void {
  resolvedConfig = null
}
